import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHttpClient } from '../../../../shared/http-client';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { MantenimientoTabForm } from './mantenimiento-tab-form';
import { Formik } from 'formik';
import { Input } from '../../../../elements/input';
import { DatePicker } from '../../../../elements/date-picker';
import { Button } from '../../../../elements/button';

// construccion del objeto yup de validacion del cuestionario
let obligado = {};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    next_maintenance_mileage: '',
    next_maintenance_date: '',
};


export const MantenimientoTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [refresh, setRefresh] = useState<string | null>(null);


    // Load initial data
    useEffect(() => {
        if (item) {
            api(`/fleet/vehicles/${item}/`, 'GET');
        }
    }, [item]);

    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
        window.location.reload();
    };

    const handleNewAction = () => {
        open('common.form-title.new', <MantenimientoTabForm close={handleClose} vehicleId={item} />);
    };

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };


        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        const send = { next_maintenance_mileage: enviaremos.next_maintenance_mileage, next_maintenance_date: enviaremos.next_maintenance_date }

        api(`/fleet/vehicles/${item}/`, 'PATCH', send);

    };


    const onReset = async () => {

        const send = { next_maintenance_mileage: null, next_maintenance_date: null }

        api(`/fleet/vehicles/${item}/`, 'PATCH', send);

    };


    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('fleet/vehicles')) {
                if (state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    window.location.reload();

                }
                if (state.method === 'GET') {
                    setData(state.data)

                }
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }
        }
    }, [state]);



    return (
        <>

            <PageBody
                newAction={handleNewAction}
                newActionTitle={'common.form-title.new'}
                title={'common.label.mantenimiento'}
            //titleStatus={'OK'}

            >
                <div>
                    <Formik
                        initialValues={data || initialValues}
                        onSubmit={onSubmit}
                        validationSchema={validacion}
                        enableReinitialize
                    >
                        {({
                            values,
                            errors,
                            touched,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting
                        }) => (
                            <form onSubmit={handleSubmit} autoComplete="off">

                                <div className='flex'>
                                    <div>
                                        <Input
                                            label={t('common.label.km-proximo-mantenimiento')}
                                            type="number"
                                            placeholder={t('common.label.km-proximo-mantenimiento')}
                                            name="next_maintenance_mileage"
                                            value={values.next_maintenance_mileage}
                                            onChange={(value) =>
                                                setFieldValue('next_maintenance_mileage', value.next_maintenance_mileage)
                                            }
                                        />
                                    </div>
                                    <div className='pl-4'>
                                        <DatePicker
                                            name="next_maintenance_date"
                                            type="date"
                                            label={t(
                                                'common.label.fecha-proximo-mantenimiento'
                                            )}
                                            value={
                                                (data
                                                    ? dayjs(
                                                        data.next_maintenance_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : '') ||
                                                values.next_maintenance_date
                                            }
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'next_maintenance_date',
                                                    value.next_maintenance_date
                                                        ? dayjs(
                                                            value.next_maintenance_date
                                                        ).format(
                                                            'YYYY-MM-DD'
                                                        )
                                                        : null
                                                );
                                            }}
                                        />
                                    </div>
                                    <div className='flex'>
                                        <div className='pl-8 mt-[30px] w-36'>
                                            <Button label={t('common.label.actualizar')} onClick={handleSubmit} block />
                                        </div>
                                        <div className='ml-8 mt-[30px] w-28'>
                                            <Button label={t('Reset')} onClick={onReset} block outlined />
                                        </div>
                                    </div>

                                </div>
                            </form>
                        )}
                    </Formik>
                    <Table
                        path={`/fleet/maintenances/?vehicle=${item}&`}
                        deletePath={`/fleet/maintenances/`}
                        callBeforeDrawerClosed={handleClose}
                        Form={MantenimientoTabForm}
                        withPagination
                        refresh={refresh}
                        headers={[
                            {
                                key: 'type',
                                subKey: 'name',
                                label: 'common.label.tipo-mantenimiento',
                            },
                            {
                                key: 'center',
                                subKey: 'name',
                                label: 'common.label.centro',
                            },
                            {
                                key: 'cost',
                                label: 'common.label.costo',
                            },
                            {
                                key: 'observations',
                                label: 'common.label.observaciones',
                            },
                            {
                                key: 'mileage',
                                label: 'common.label.kilometraje-mantenimiento',
                            },
                            {
                                key: 'date',
                                type: 'date',
                                label: 'common.labels.date',
                            },
                            {
                                key: 'status',
                                type: 'status',
                                label: 'common.label.estado',
                            },
                        ]}
                    />
                </div>

            </PageBody>
        </>

    );
};